import { render, staticRenderFns } from "./UsageRecordingCandidates.vue?vue&type=template&id=2a6b20f0&"
import script from "./UsageRecordingCandidates.vue?vue&type=script&lang=js&"
export * from "./UsageRecordingCandidates.vue?vue&type=script&lang=js&"
import style0 from "./UsageRecordingCandidates.vue?vue&type=style&index=0&id=2a6b20f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports